import { FAILED, IN_CAPTURATE, IN_PROGRESS, SUCCEEDED } from "constants/common";
import { isEmpty } from "lodash";
import { UploadRequestPayloadTypes } from "models/Widget";
import { useMemo } from "react";
import { useSelector } from "react-redux";

export const useUploadProgress = () => {
	const {
		fileProgress,
		isCancelledProgressModal = false,
		uploadedContentListResult,
		createContentStatus,
	} = useSelector((state: any) => state.widgets);

	const isInProgress = useMemo(() => {
		return fileProgress.some(
			(item: UploadRequestPayloadTypes) =>
				item.status === IN_PROGRESS || item.status === IN_CAPTURATE,
		);
	}, [fileProgress, isCancelledProgressModal]);

	const isCompleteUpload = useMemo(() => {
		const fileInSucceed = fileProgress.filter(
			(item: UploadRequestPayloadTypes) => item.status === SUCCEEDED,
		);

		return (
			!!fileProgress.length &&
			!!uploadedContentListResult.length &&
			!isInProgress &&
			uploadedContentListResult.filter((item: any) => !item.limitationError).length ===
				fileInSucceed.length
		);
	}, [isInProgress, fileProgress, uploadedContentListResult]);

	const isInError = useMemo(() => {
		return (
			fileProgress.every((item: UploadRequestPayloadTypes) => !isEmpty(item?.limitationError)) ||
			createContentStatus === FAILED
		);
	}, [fileProgress, isCancelledProgressModal]);

	return {
		isInProgress,
		isCompleteUpload,
		isInError,
	};
};
